import { syntaxTree } from "@codemirror/language";

import { commonAncestor, matchingAncestor } from "./ancestors.js";

export const formattingCommandMap = {
    "\\textbf": "TextBoldCommand",
    "\\textit": "TextItalicCommand",
};

export const withinFormattingCommand = (state) => {
    const tree = syntaxTree(state);

    return (command) => {
        const nodeType = formattingCommandMap[command];

        const isFormattedText = (range) => {
            const nodeLeft = tree.resolveInner(range.from, -1);
            const formattingCommandLeft = matchingAncestor(nodeLeft, (node) => node.type.is(nodeType));
            if (!formattingCommandLeft) {
                return false;
            }

            const nodeRight = tree.resolveInner(range.to, 1);
            const ancestor = commonAncestor(formattingCommandLeft, nodeRight);
            if (!ancestor) {
                return false;
            }

            const formattingAncestor = matchingAncestor(ancestor, (node) => node.type.is(nodeType));
            return Boolean(formattingAncestor);
        };

        return state.selection.ranges.every(isFormattedText);
    };
};
